import { Youtube } from "assets/icons";
import { InformationSetting, RememberSettings } from "components/settings";
import { WidgetNames } from "constants/widgets";

import { TextAreaSettings } from "./components";
import { YoutubeContainer } from "./Youtube";

export const YoutubeWidget: any = {
  name: "Youtube",
  component: YoutubeContainer,
  icon: Youtube,
  showOnToolbar: true,
  sizing: {
    minWidth: 150,
    minHeight: 120,
    minAspectRatio: 0.5,
    maxAspectRatio: 1.5,
  },
  defaultState: {
    placeholder: "Add your embed code here...",
    hasError: false,
  },
  defaultSize: {
    aspectRatio: 2,
    widthPercentage: 30,
  },
  settings: {
    header: {
      editor: InformationSetting,
      info: {
        info: "Insert your youtube link here",
      },
    },
    data: {
      editor: TextAreaSettings,
      info: {
        placeholder: "Add your embed code here...",
        settingName: "Embed code",
      },
    },
    rememberSettings: {
      editor: RememberSettings,
      info: {
        widgetName: WidgetNames.youtube,
        widgetDisplayName: "Youtube",
      },
    },
  },
  quickActions: {},
};
